import { Controller } from "@hotwired/stimulus"
import Sortable from "sortablejs"

// Two-level drag-sort. The parent list and every nested list (marked with
// data-nested-sortable-url) are created imperatively from this single
// controller — so reordering a parent item never disconnects a *child*
// Stimulus controller mid-drag (which would stall the drag and skip the save).
//
//   <div data-controller="sortable-tree"
//        data-sortable-tree-url-value="/admin/categories/reorder"
//        data-sortable-tree-handle-value=".cat-handle"
//        data-sortable-tree-nested-handle-value=".tcz-handle">
//     <div data-sortable-id="1">
//       <ul data-nested-sortable-url="/admin/tag_categorizations/reorder">
//         <li data-sortable-id="9">…</li>
//       </ul>
//     </div>
//   </div>
export default class extends Controller {
  static values = { url: String, handle: String, nestedHandle: String }

  connect() {
    this.instances = []
    this.instances.push(this.build(this.element, this.urlValue, this.handleValue))
    this.element.querySelectorAll("[data-nested-sortable-url]").forEach((list) => {
      this.instances.push(this.build(list, list.dataset.nestedSortableUrl, this.nestedHandleValue))
    })
  }

  disconnect() {
    this.instances.forEach((instance) => instance.destroy())
    this.instances = []
  }

  build(element, url, handle) {
    return Sortable.create(element, {
      handle: handle || null,
      draggable: "[data-sortable-id]",
      swapThreshold: 0.65,
      animation: 150,
      onEnd: () => this.save(element, url)
    })
  }

  save(element, url) {
    const ids = Array.from(element.querySelectorAll(":scope > [data-sortable-id]"))
      .map((item) => item.dataset.sortableId)

    fetch(url, {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json",
        "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]')?.content
      },
      body: JSON.stringify({ ids })
    })
  }
}
